var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3541 12.9795C10.4006 13.026 10.4374 13.0811 10.4626 13.1418C10.4877 13.2025 10.5007 13.2676 10.5007 13.3333C10.5007 13.399 10.4877 13.464 10.4626 13.5247C10.4374 13.5854 10.4006 13.6406 10.3541 13.687C10.3077 13.7335 10.2525 13.7703 10.1918 13.7955C10.1311 13.8206 10.0661 13.8336 10.0004 13.8336C9.9347 13.8336 9.86964 13.8206 9.80895 13.7955C9.74825 13.7703 9.6931 13.7335 9.64664 13.687L4.64664 8.68704C4.60015 8.6406 4.56328 8.58545 4.53811 8.52476C4.51295 8.46406 4.5 8.39899 4.5 8.33329C4.5 8.26758 4.51295 8.20251 4.53811 8.14182C4.56328 8.08112 4.60015 8.02597 4.64664 7.97954L9.64664 2.97954C9.74046 2.88572 9.86771 2.83301 10.0004 2.83301C10.1331 2.83301 10.2603 2.88572 10.3541 2.97954C10.448 3.07336 10.5007 3.2006 10.5007 3.33329C10.5007 3.46597 10.448 3.59322 10.3541 3.68704L5.70727 8.33329L10.3541 12.9795Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.3c901dfa1985fa086c7d5bd7671b8d94.svg";
export { ForwardRef as ReactComponent };